import { render } from "./waiter.vue?vue&type=template&id=935cb91a"
import script from "./waiter.vue?vue&type=script&lang=js"
export * from "./waiter.vue?vue&type=script&lang=js"

import "./waiter.vue?vue&type=style&index=0&id=935cb91a&lang=scss"
script.render = render

export default script